import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { CaretDownIcon } from '@phosphor-icons/react'

/**
 * The `<summary>` for a native `<details>` disclosure, with the app's caret in
 * place of the browser's text triangle. The caret flips when its own
 * disclosure opens, so mark that `<details>` with `group/disclosure` (a named
 * group, so a disclosure nested inside another doesn't flip with the outer).
 */
export function DisclosureSummary({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <summary
      className={cn(
        'flex cursor-pointer select-none list-none items-center gap-2 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring [&::-webkit-details-marker]:hidden',
        className,
      )}
    >
      <span className="min-w-0 flex-1">{children}</span>
      <CaretDownIcon
        aria-hidden="true"
        className="h-3.5 w-3.5 shrink-0 opacity-70 transition-transform duration-150 group-open/disclosure:rotate-180 motion-reduce:transition-none"
      />
    </summary>
  )
}
